import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// interfaces
import { IAuctionService } from "../../../shared/interfaces/auction";

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';
import { Auction } from '../../../shared/models/auction';

// services
import { WebApiService } from '../../../shared/services/web-api.service';

@Injectable()
export class AuctionService implements IAuctionService{

  private apiPath: string;
  private buyerId: number;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'buyerlevel';
  }

  setId(id: number) {
    this.buyerId = id;
  }

  //IAuctionService

  getAuctionsForReports(auctionClusterId: number): Observable<Array<Auction>> {
    return this.webApiService.getList(`${this.apiPath}/${this.buyerId}/auctioncluster/auction`);
  }  
}
